import React, { Suspense, useEffect, useRef, useState } from "react";
import Buttons from "../../components/ui/button/Buttons";
import AccounntInformation from "./commponent/AccountInformation/AccountInformation"
import MembershipSubscription from "./commponent/MembershipSubscription/MembershipSubscription";
import CorporateInformation from "./commponent/CorporateInformation/CorporateInformation";
import BusinessActivity from "./commponent/BusinessActivity/BusinessActivity";
import OtherInformation from "./commponent/OtherInformation/OtherInformation";
import KeyPositions from "./commponent/MemberkeyPositions/KeyPositions";
import EmployeesList from "./commponent/EmployeesList/EmployeesList";
import FinancialRecords from "./commponent/FinancialRecords/FinancialRecords";
import { useLazyGetSignUpDropDownsForCorporateMembersQuery } from "../../app/services/common/commonApi";
import { setAllDropDownFieldForViewMember } from "./utils/dropdownUtils";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import { useLazyGetCorporateMemberDetailsByCorporateMemberIdQuery } from "../../app/services/corporateMembership/corporateMemberApi";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { setFieldParameter, setFieldParameterForMembership } from "./utils/setFieldParameter";
import { useLazyGetMembershipSubscriptionForCorporateMemberDetailByIdQuery } from "../../app/services/CorporateMembershipTaskList/corporateMembershipTaskListApi";

const ViewCorporateMembersDetailForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const AccountInformationRef = useRef();
  const MembershipSubscriptionRef = useRef();
  const CorporateInformationRef = useRef();
  const OtherInformationRef = useRef();
  const BusinessActivityRef = useRef();
  const [isEmployee, setIsEmployee] = useState(false);
  const [signUpDropDownsForCorporateMembers, { data: signUpDropDownsData, isLoading: signUpDropDownsLoading, isFetching: signUpDropDownsFetching, isError: signUpDropDownsIsError, error: signUpDropDownsError, }] = useLazyGetSignUpDropDownsForCorporateMembersQuery()
  const [getCorporateMemberDetailsByCorporateMemberId, { data: corporateMemberDetails, isLoading: corporateMemberDetailsLoading, isFetching: corporateMemberDetailsFetching, isError: corporateMemberDetailsIsError, error: corporateMemberDetailsError, }] = useLazyGetCorporateMemberDetailsByCorporateMemberIdQuery()
  const [getMembershipSubscriptionForCorporateMemberDetail, { data: getMembershipSubscriptionForCorporateMemberDetailData, isLoading: getMembershipSubscriptionForCorporateMemberDetailLoading, isFetching: getMembershipDetailsIsFetching, }] = useLazyGetMembershipSubscriptionForCorporateMemberDetailByIdQuery()

  useEffect(() => {
    signUpDropDownsForCorporateMembers()
    if (id) {
      getCorporateMemberDetailsByCorporateMemberId(editID)
      getMembershipSubscriptionForCorporateMemberDetail(editID)
    }
  }, [id]);

  useEffect(() => {
    if (!corporateMemberDetailsLoading && corporateMemberDetails) {
      setFieldParameter(corporateMemberDetails);
    }
  }, [corporateMemberDetailsLoading, corporateMemberDetails]);

  useEffect(() => {
    if (!getMembershipSubscriptionForCorporateMemberDetailLoading && getMembershipSubscriptionForCorporateMemberDetailData) {
      setFieldParameterForMembership(getMembershipSubscriptionForCorporateMemberDetailData);
    }
  }, [getMembershipSubscriptionForCorporateMemberDetailLoading, getMembershipSubscriptionForCorporateMemberDetailData]);

  useEffect(() => {
    if (!signUpDropDownsLoading && signUpDropDownsData) {
      setAllDropDownFieldForViewMember(signUpDropDownsData);
    }
  }, [signUpDropDownsLoading, signUpDropDownsData]);

  const handleBack = () => {
    window.history.back();
  };

  return (
    <>
      {signUpDropDownsData && getMembershipSubscriptionForCorporateMemberDetailData ?
        <div className="view-corporate-member">
          <AccounntInformation ref={AccountInformationRef} />
          <MembershipSubscription ref={MembershipSubscriptionRef} membershipDetails={getMembershipSubscriptionForCorporateMemberDetailData} />
          <CorporateInformation id={editID} corporateMemberDetails={corporateMemberDetails} ref={CorporateInformationRef} />
          <BusinessActivity id={editID} ref={BusinessActivityRef} dropDownList={signUpDropDownsData} corporateMemberDetails={corporateMemberDetails} />
          <OtherInformation id={editID} ref={OtherInformationRef} corporateMemberDetails={corporateMemberDetails} />
          <KeyPositions id={editID} setIsEmployee={setIsEmployee} dropDownList={signUpDropDownsData} />
          <EmployeesList isEmployee={isEmployee} setIsEmployee={setIsEmployee}/>
          <FinancialRecords />
          <Buttons
            buttonText="Back" 
            buttonTypeClassName="black-btn"
            onClick={handleBack}
          />
        </div>
        : <DataLoader />}
    </>
  );
};

export default ViewCorporateMembersDetailForm;
